import api from '../common/helpers/apiHelper';
import { INameData } from '../common/models/common/INameData';
import { IRefReqCounters } from '../common/models/referenceRequest/IRefReqCounters';
import { IApiToken } from '../common/models/workspace/IApiToken';
import { IWorkspaceIntegrations } from '../common/models/workspace/IWorkspaceIntegrations';

export const getWorkspaceApiTokens = () => api.get<IApiToken[]>('/api/workspaces/api-tokens');

export const createWorkspaceApiToken = (name: string) => api.post<{ apiToken: string; name: string }>(
  '/api/workspaces/api-token', { name }
);

export const deactivateWorkspaceApiToken = (name: string) => api.put(
  '/api/workspaces/api-token/deactivate', { name }
);

export const reactivateWorkspaceApiToken = (name: string) => api.put(
  '/api/workspaces/api-token/reactivate', { name }
);

export const deleteWorkspaceApiToken = (name: string) => api.delete(`/api/workspaces/api-token/${name}`);

export const updateDefaultCounters = (counters: IRefReqCounters) => api.put<IRefReqCounters>(
  '/api/workspaces/default-counters', counters
);

export const completeLeverIntegration = (code: string) => api.post<void>('/api/workspaces/lever', { code });

export const getIntegrationsData = () => api.get<IWorkspaceIntegrations>('/api/workspaces/integrations');

export const deleteLeverIntegration = () => api.delete<void>('/api/workspaces/lever');

export const updateLeverStage = (id: string) => api.put<void>('/api/workspaces/lever/stage', { id });

export const updateLeverSurvey = (id: string) => api.put<void>('/api/workspaces/lever/survey', { id });

export const getLeverStages = () => api.get<INameData[]>('/api/workspaces/lever/stages');
